import API from "../utilities/LocalApiProxy";
import { isRateLimitError } from "./errorActions";

import {
	GET_PERMISSION_GROUPS_REQUEST,
	GET_PERMISSION_GROUPS_SUCCESS,
	GET_PERMISSION_GROUPS_FAILURE,
	CREATE_PERMISSION_GROUP_REQUEST,
	CREATE_PERMISSION_GROUP_SUCCESS,
	CREATE_PERMISSION_GROUP_FAILURE,
	DELETE_PERMISSION_GROUP_REQUEST,
	DELETE_PERMISSION_GROUP_SUCCESS,
	DELETE_PERMISSION_GROUP_FAILURE,
	GET_DEFAULT_MATTER_PERMISSIONS_REQUEST,
	GET_DEFAULT_MATTER_PERMISSIONS_SUCCESS,
	GET_DEFAULT_MATTER_PERMISSIONS_FAILURE,
	UPDATE_DEFAULT_MATTER_PERMISSIONS_REQUEST,
	UPDATE_DEFAULT_MATTER_PERMISSIONS_SUCCESS,
	UPDATE_DEFAULT_MATTER_PERMISSIONS_FAILURE,
	OPEN_GLOBAL_SNACKBAR,
} from "./types";

export function getPermissionGroupsV2(groupID) {
	return function (dispatch) {
		dispatch({ type: GET_PERMISSION_GROUPS_REQUEST });
		API.post("/permissions/groups/v2/list", { body: { groupID } })
			.then((res) => {
				dispatch({
					type: GET_PERMISSION_GROUPS_SUCCESS,
					payload: {
						availableGroups: res.mysql.groups,
						groupMembership: res.mysql.groupMembership,
						users: res.mysql.users,
					},
				});
			})
			.catch((err) => {
				dispatch({
					type: GET_PERMISSION_GROUPS_FAILURE,
					payload: { rateLimited: isRateLimitError(err) },
				});
			});
	};
}
export function getRightsForUser(userSub) {
	return function (dispatch) {
		dispatch({ type: "GET_RIGHTS_FOR_USER_REQUEST" });
		API.post("/permissions/user/calculateRights", { body: { userSub } })
			.then((res) => {
				dispatch({
					type: "GET_RIGHTS_FOR_USER_SUCCESS",
					payload: {
						userRights: res.mysql,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: "GET_RIGHTS_FOR_USER_FAILURE",
				});
			});
	};
}
export function getPermissionGroupDetails(groupID) {
	return function (dispatch) {
		dispatch({ type: "GET_PERMISSION_GROUP_REQUEST" });
		API.post("/permissions/group/details", { body: { groupID } })
			.then((res) => {
				dispatch({
					type: "GET_PERMISSION_GROUP_SUCCESS",
					payload: {
						group: res.mysql.group,
						groupMembers: res.mysql.groupMembers,
						users: res.mysql.users,
						groupPermissionFeatures:
							res.mysql.groupPermissionFeatures,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: "GET_PERMISSION_GROUP_FAILURE",
				});
			});
	};
}
export function updatePermissionGroupDetails({
	groupID,
	name,
	groupMembers,
	groupPermissionFeatures,
}) {
	return function (dispatch) {
		dispatch({ type: "UPDATE_PERMISSION_GROUP_DETAILS_REQUEST" });
		API.post("/permissions/group/update", {
			body: { groupID, name, groupMembers, groupPermissionFeatures },
		})
			.then(() => {
				dispatch({
					type: "UPDATE_PERMISSION_GROUP_DETAILS_SUCCESS",
				});
				window.globalHistory.push(`/permissions/groups/list`);
			})
			.catch(() => {
				dispatch({
					type: "UPDATE_PERMISSION_GROUP_DETAILS_FAILURE",
				});
			});
	};
}
export function unmountEditPermissionGroup() {
	return function (dispatch) {
		dispatch({ type: "UNMOUNT_EDIT_PERMISSION_GROUP" });
	};
}
export function createPermissionGroupV2(groupData) {
	return function (dispatch) {
		dispatch({ type: CREATE_PERMISSION_GROUP_REQUEST });
		API.post("/permissions/group/create", { body: { groupData } })
			.then(() => {
				dispatch({
					type: CREATE_PERMISSION_GROUP_SUCCESS,
				});
				window.globalHistory.push(`/permissions/groups/list`);
			})
			.catch(() => {
				dispatch({
					type: CREATE_PERMISSION_GROUP_FAILURE,
				});
			});
	};
}
export function deletePermissionGroup(groupID) {
	return function (dispatch) {
		dispatch({ type: DELETE_PERMISSION_GROUP_REQUEST });
		API.post("/permissions/groups/delete", {
			body: { groupID },
		})
			.then(() => {
				dispatch({
					type: DELETE_PERMISSION_GROUP_SUCCESS,
				});
				getPermissionGroupsV2()(dispatch);
			})
			.catch(() => {
				dispatch({
					type: DELETE_PERMISSION_GROUP_FAILURE,
				});
			});
	};
}

export function getDefaultMatterPermissions() {
	return function (dispatch) {
		dispatch({ type: GET_DEFAULT_MATTER_PERMISSIONS_REQUEST });
		API.get("/permissions/defaultMatter")
			.then((results) => {
				dispatch({
					type: GET_DEFAULT_MATTER_PERMISSIONS_SUCCESS,
					payload: {
						matterPermissionGlobalSetting:
							results.mysql.matterPermissionGlobalSetting,
						userAllowList: results.mysql.userAllowList,
						groupAllowList: results.mysql.groupAllowList,
						availableUsers: results.mysql.availableUsers,
						availableGroups: results.mysql.availableGroups,
						allowSelfAddToMatter:
							results.mysql.allowSelfAddToMatter || false,
					},
				});
			})
			.catch(() => {
				dispatch({ type: GET_DEFAULT_MATTER_PERMISSIONS_FAILURE });
			});
	};
}

export function updateDefaultMatterPermissions(permissionsData) {
	return function (dispatch) {
		dispatch({ type: UPDATE_DEFAULT_MATTER_PERMISSIONS_REQUEST });
		API.post("/permissions/defaultMatter", {
			body: {
				userAllowList: permissionsData.userAllowList,
				groupAllowList: permissionsData.groupAllowList,
				allowSelfAddToMatter: permissionsData.allowSelfAddToMatter,
			},
		})
			.then(() => {
				dispatch({ type: UPDATE_DEFAULT_MATTER_PERMISSIONS_SUCCESS });
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message:
							"Default matter permissions saved successfully",
					},
				});
				// Refresh the data
				dispatch(getDefaultMatterPermissions());
			})
			.catch(() => {
				dispatch({ type: UPDATE_DEFAULT_MATTER_PERMISSIONS_FAILURE });
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "error",
						message: "Failed to save default matter permissions",
					},
				});
			});
	};
}
